<template>
  <div class="base-grid-table-root" v-show="tabledata">
    <div class="vtable-grid inside-box" ref="gridContainer">
      <ul class="">
        <template v-for="(item, index) in tabledata.items" :key="item.uuid || item.id || index">
          <li @click="selectRow(item, $event)">
            <div class="row-header-sentinel" :ref="el => observeSentinel(el, index)"></div>
            <div class="row-header" :class="{'is-stuck': stuckIndexes.has(index)}">
              <template v-for="(column, indexColumn) in tabledata.columns" :key="`header_${indexColumn}`">
                <slot v-if="column.key == 'name'" :name="`column_${column.key}`" :item="item" onclick="return false"></slot>
                <slot v-if="column.type == 'custom' && column.key != 'captures'" :name="`column_${column.key}`" :item="item" onclick="return false"></slot>
              </template>
            </div>

            <template v-for="(column, indexColumn) in tabledata.columns" :key="indexColumn">
              <slot v-if="column.type == 'custom' && column.key == 'captures'" :name="`column_${column.key}`" :item="item" onclick="return false"></slot>
              <span v-if="column.type == 'externalDate'" :class="column.type">{{ formatDate(item, column.value) }}</span>
              <span v-if="column.type == undefined || column.type == 'string' && column.key != 'name'" onclick="return false">{{ getValue(item, column.value) }}</span>
            </template>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.base-grid-table-root {
  flex:                           1;
  display:                        flex;
  flex-direction:                 column;
  min-height:                     0;
}

.vtable-grid {
  flex:                           1;
  min-height:                     0;
  overflow-y:                     auto;
}

.row-header-sentinel {
  position:                       absolute;
  top:                            0;
  width:                          1px;
  height:                         1px;
  pointer-events:                 none;
}

.btn-load {
  color:                          var(--Brand-Primary);
  display:                        block;
  margin:                         0 auto;
  padding:                        10px 20px;
  background:                     var(--Shades-BG);
  border:                         1px solid var(--Shades-30-Border);
}
</style>

<script>
import { useExamFilterStore } from '@/store/examFilter'

export default {
  name: 'BaseTable',
  props: {
    tabledata: { type: Object }
  },
  data: () => ({
    dateFormat: "",
    previousScrollHeight: null,
    stuckIndexes: new Set(),
    stickyObserver: null,
  }),
  watch: {
    'tabledata.items'(newItems, oldItems) {
      const gridContainer = this.$refs.gridContainer;
      gridContainer.scrollTop = 0;
      this.stickyObserver?.disconnect()
      this.stuckIndexes.clear();
    },
  },
  computed: {
    isExamRoute() {
      return this.$router.currentRoute._value.name == 'exam-list'
    }
  },
  mounted() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    this.dateFormat = this.$i18n.t('dateTimeFormat')

    this.stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const index = Number(entry.target.dataset.index)
        const scrolledPastTop = entry.boundingClientRect.top < entry.rootBounds?.top

        if (!entry.isIntersecting && scrolledPastTop)
          this.stuckIndexes.add(index)
        else
          this.stuckIndexes.delete(index)
      })
    }, {
      root: this.$refs.gridContainer,
      threshold: 0,
      rootMargin: '-1px 0px 0px 0px'
    })
  },
  methods: {
    observeSentinel(el, index) {
      if (!el || !this.stickyObserver)
        return

      el.dataset.index = index
      this.stickyObserver.observe(el)
    },
    getValue(data, key) {
      return _.get(data, key)
    },
    formatDate(data, key) {
      let value = _.get(data, key)
      let result = moment(value).format(this.dateFormat);
      return result
    },
    selectRow(item, event) {
      let isCommandPressed = event.ctrlKey || (event.button === 1)
      this.$emit('item-opened', {item, commandPressed: isCommandPressed})
    },
    // @deprecated
    checkStatus(status) {
      if (status === 'Closed' || status === 'Fechado' || status === 'closed' || status === 'fechado')
        return 'label-closed';

      return 'label-open';
    },
  },
  beforeUnmount() {
    this.stickyObserver?.disconnect()
  }
}
</script>
